import { menuAnatomy as r } from "@chakra-ui/anatomy";
import { createMultiStyleConfigHelpers as i, defineStyle as t } from "@chakra-ui/react";
import { runIfFn as e } from "../../../utils/isFunction.mjs";
import n from "../../foundations/z-index.mjs";
const { defineMultiStyleConfig: a, definePartsStyle: l } = i(r.keys), s = t({
  bg: "white",
  boxShadow: "lg",
  minW: "3xs",
  p: "2",
  zIndex: n.popover,
  borderRadius: "lg",
  borderWidth: "1px",
  borderColor: "gray.200",
  gap: "4px 0px",
  display: "flex",
  flexWrap: "wrap",
  flexDir: "column"
}), d = t({
  textStyle: "bodySmall",
  py: "0.5",
  px: "2",
  transitionProperty: "background",
  transitionDuration: "ultra-fast",
  transitionTimingFunction: "ease-in",
  alignItems: "start",
  _focus: {
    color: "inherit",
    bg: "gray.100",
    borderRadius: "lg"
  },
  _hover: {
    color: "inherit",
    bg: "gray.100",
    borderRadius: "lg"
  },
  _active: {
    color: "inherit",
    bg: "teal.100",
    borderRadius: "lg"
  },
  _disabled: {
    opacity: 0.5,
    cursor: "not-allowed",
    _active: { bg: "inherit" },
    _focus: { bg: "inherit" }
  },
  "span.chakra-menu__icon-wrapper": {
    display: "inline"
  }
}), m = t({
  mx: 2,
  my: 1,
  textStyle: "bodyBoldSmall"
}), y = t({
  opacity: 0.6
}), b = t({
  border: 0,
  borderBottom: "1px solid",
  borderColor: "inherit",
  my: "2",
  opacity: 0.6
}), c = t({
  transitionProperty: "common",
  transitionDuration: "normal",
  textStyle: "body",
  _focus: {
    boxShadow: "outline"
  }
}), p = l((o) => ({
  button: c,
  list: e(s, o),
  item: e(d, o),
  groupTitle: m,
  command: y,
  divider: b
})), x = a({
  baseStyle: p
});
export {
  x as default,
  x as menuTheme
};
